export const AUTHENTICATED: string = 'authenticated_user';
export const UNAUTHENTICATED: string = 'unauthenticated_user';
export const AUTHENTICATION_ERROR: string = 'authentication_error';
export const REQUEST_LOGIN: string = "login_request";
export const REQUEST_LOGOUT: string = "logout_request";
export const REQUEST_FORGOT_PASSWORD: string = "forgot_password_request";
export const REQUEST_RESET_PASSWORD: string = "reset_password_request";
export const SET_USER = "set_user";
export const SET_CUSTOMER = "set_customer";